import planoSemSites from './planoSemSites.js'
import listaDeSites from './listaDeSites.js'
import criarNovoSite from './criarNovoSite.js'

export default {
  planoSemSites,
  listaDeSites,
  criarNovoSite
}
